// extracted by mini-css-extract-plugin
module.exports = {"title":"dp-7pYtDSKJ","infoContent":"dp-yIGoP5LQ","desc":"dp-a3hSkjHB","list":"dp-GwI2Amge"};